import React from 'react'
import video from "../assets/Samurai.mp4";
import workspace from "../assets/workspace.jpg"
import styled from 'styled-components';

function Background() {
  return (
    <VideoCont>
      <video
        playsInline
        autoPlay
        muted
        loop
        preload="auto"
        id="bg"
      >
        <source src={video} type="video/mp4" />
      </video>
      <img src={workspace} />
    </VideoCont>
  )
}

export default Background

const VideoCont = styled.div`
  position: relative;
  video{
    width: 99vw;
    height: 100vh;
    object-fit: cover;
    position: absolute;
    left: 0;
    right: 0;
    top: 0; 
    z-index: -1;
  }
  img{
    position: fixed;
    left: 0;
    right 0;
    height: 100vh;
    width: 99vw;
    object-fit: cover;
    filter: brightness(45%);
    z-index: -2;
  }
`